import { useEffect } from 'react';

import { useNavigate } from 'react-router-dom';

import { useDutchieIntelligenceContext } from '../context/dutchie-intelligence';

/**
 * ActionRegistry - Placeholder for AI action registration.
 *
 * This bridge will eventually:
 * 1. Register navigation action with react-router navigate function
 * 2. Set custom-actions context with all registered actions
 * 3. Mark actions as global so they're available on all pages
 *
 * For now, it's a stub that will be filled in when we implement the action system.
 */
export function ActionRegistry() {
  const navigate = useNavigate();
  const { setComponentContext } = useDutchieIntelligenceContext();

  useEffect(() => {
    // Placeholder: In the future, this will register all available AI actions
    // For now, just register a simple context showing that the registry exists
    const placeholderActions = {
      _note: 'Action system not yet implemented',
      _availableActions: [],
      _description: 'This will contain all AI-executable actions once the action system is built',
    };

    setComponentContext('custom-actions', JSON.stringify(placeholderActions), 'app', {
      global: true,
      type: 'other',
      source: 'manual',
      priority: 'low',
    });
  }, [navigate, setComponentContext]);

  return null; // This is a logical component, renders nothing
}
